import { useEffect, useState } from "react";
import { SocialMediaLink, fetchBannerData } from "src/util/bannerService";

export function useSocialMediaLinks(brandId?: string | number) {
    const [socialMediaLinks, setSocialMediaLinks] = useState<SocialMediaLink[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (brandId === undefined || brandId === null || brandId === "") {
            setSocialMediaLinks([]);
            setLoading(false);
            return;
        }

        let isMounted = true;

        const fetchSocialMediaLinks = async () => {
            setLoading(true);

            try {
                const response = await fetchBannerData(String(brandId));
                const socialLinks = response?.socialMediaLinks ?? [];

                if (isMounted) {
                    setSocialMediaLinks(socialLinks);
                }
            } catch (error) {
                console.error("Failed to fetch social media links", error);

                if (isMounted) {
                    setSocialMediaLinks([]);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchSocialMediaLinks();

        return () => {
            isMounted = false;
        };
    }, [brandId]);

    return {
        socialMediaLinks,
        loading,
        hasSocialLinks: socialMediaLinks.length > 0,
    };
}